module.exports = __webpack_public_path__ + "img/rbcn_pro_show_1_h.5492bee7.jpg";